import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { selectAtom } from 'jotai/utils';
import { getQueryString } from 'containers/App/ParamsExtractor/getQueryString';
import { useLocation } from 'react-router-dom';

interface Payload {
  viewId?: string;
}

const payloadAtom = atom<Payload | undefined>(undefined);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
export const useIsOpenAddEleveModal = () => {
  const location = useLocation();
  const v = useAtomValue(isOpenAtom);
  const isQueryStringOpen = !!getQueryString(location)?.open || false;
  if (isQueryStringOpen) {
    return true;
  }
  return v;
};

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, undefined));
export const useCloseAddEleveModal = () => useSetAtom(closeModalAtom);

export const useOpenAddEleveModal = () => useSetAtom(payloadAtom);

export const useGetAddElevePayload = () => useAtomValue(payloadAtom);
